export default __webpack_public_path__ + "static/media/31.8312f469.jpg";